import { useAppDispatch, useAppSelector } from '~/redux/hooks'

import { selectBossSound, setToggleBossSound } from '~/bootcamp/slices/bootcamp-quiz.slice'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import VolumeOnIcon from '~/components/Icons/svgs/VolumeOnIcon'
import VolumeOffIcon from '~/components/Icons/svgs/VolumeOffIcon'

import { BossSoundState } from './QuizData.models'

const BossSoundControl = ({ className, color }: { color: string; className?: string }): React.ReactElement => {
  const dispatch = useAppDispatch()
  const bossSound = useAppSelector(selectBossSound)
  const isUnmute = bossSound === BossSoundState.UNMUTE

  return (
    <div className={`cursor-pointer ${className}`} onClick={() => dispatch(setToggleBossSound())}>
      <SVGIcon icon={isUnmute ? VolumeOnIcon : VolumeOffIcon} pathClassName={color} size={35} />
    </div>
  )
}

export default BossSoundControl
